import React from 'react';
import './TeamSingle.css';

import { PageTitle } from '../../../components';

import { FaPhone, FaEnvelope} from 'react-icons/fa';

import { useLocation } from 'react-router-dom';



const TeamSingle = () => {

  const location = useLocation();
  const team = location.state;

  const contacts = team.contacts;

  return (
    <>

      {/* Page title */}
      <PageTitle title={'Rada naukowa'} page={'Rada naukowa'} />

      <section className='team-single'>

        {/* Team Member Introduction */}
        <div className='team-intro'>

          {/* Team Member Image */}
          <div className='image'>
            <img src={team.image} alt={team.name} />
          </div>

          {/* Team Member Details */}
          <div className='information'>

            <h3>{team.name}</h3> {/* Team Member Name */}
            <h5>{team.title}</h5> {/* Team Member Title */}

            {/* Team Member About */}
            <div className='team-about'>
              <div className='text'>{team.biography}</div> {/* Team Member Biography */}
            </div>

            <ul className="team-personal-info">
              <li><h6><FaPhone className='icon' /> Phone:</h6><span>{contacts.phone}</span></li>
              <li><h6><FaEnvelope className='icon' /> Email:</h6><span>{contacts.email}</span></li>
            </ul>


          </div>

        </div>

      </section>
    </>
  )
  
}

export default TeamSingle;